module.exports = __webpack_public_path__ + "img/4.fce346e7.jpeg";